import MinusSign from 'assets/icons/minus.svg';
import PlusSign from 'assets/icons/plus.svg';
import cn from 'classnames/bind';
import PropTypes from 'prop-types';
import { Text } from 'ui';

import s from './AdvantageLabel.module.scss';

const cx = cn.bind(s);

const AdvantageLabel = ({
  className,
  negative,
  text,
  ...attrs
}) => (
  <div className={cx('advantageLabel', className, { negative })} {...attrs}>
    <span className={cx('advantageIcon')}>
      {negative ? <MinusSign /> : <PlusSign />}
    </span>
    <Text variant="h4" tag="p" className={cx('advantageText')}>
      {text}
    </Text>
  </div>
);

AdvantageLabel.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export default AdvantageLabel;
